import React from 'react';
import { Box, Typography, Link } from '@mui/material';
import { Lock as LockIcon } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        py: 2,
        px: 2,
        mt: 'auto',
        textAlign: 'center',
        borderTop: '1px solid',
        borderColor: 'divider',
        backgroundColor: 'background.paper'
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          justifyContent: 'center',
          alignItems: 'center',
          gap: { xs: 0.5, sm: 2 },
          flexWrap: 'wrap',
        }}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}
        >
          <LockIcon sx={{ fontSize: 12 }} />
          Data encrypted & secured
        </Typography>
        <Typography variant="caption" color="text.secondary">
          &copy; {new Date().getFullYear()}{' '}
          <Link
            href="https://classtree.in"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="primary"
          >
            ClassTree.in
          </Link>
          {' | Powered by '}
          <Link
            href="https://ajtechlabs.in"
            target="_blank"
            rel="noopener noreferrer"
            underline="hover"
            color="primary"
          >
            ajtechlabs.in
          </Link>
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <Link
            href="mailto:support@classtree.in"
            underline="hover"
            color="primary"
          >
            Contact Support
          </Link>
        </Typography>
        <Typography variant="caption" color="text.secondary">
          <Link
            component={RouterLink}
            to="/terms"
            underline="hover"
            color="primary"
          >
            Terms &amp; Conditions
          </Link>
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
